import { useMutation } from '@tanstack/react-query';
import { searchContentService } from './SmartMentor.services';

export const useSearchContentMutation = () => useMutation(searchContentService);
